import { IFormErrors } from '@interfaces/IFormsErrors';
import { INoteData } from '@interfaces/INoteData';
import { IStudentGenerateFinalResults } from '@interfaces/IStudentResults';
import { IUser } from '@interfaces/IUser';
import { Action } from '@ngrx/store';

export enum EUsersChangesActions {
  ResetState = '[Users-changes] Reset state',

  EditUserRequest = '[Users-changes] Edit User Request',
  EditUserSuccess = '[Users-changes] Edit User Success',
  EditUserFailure = '[Users-changes] Edit User Failure',

  DeleteUserRequest = '[Users-changes] Delete User Request',
  DeleteUserSuccess = '[Users-changes] Delete User Success',
  DeleteUserFailure = '[Users-changes] Delete User Failure',

  SendBlockStudentRequest = '[Users-changes] Send Block Student Request',
  SendBlockStudentSuccess = '[Users-changes] Send Block Student Success',
  SendBlockStudentFailure = '[Users-changes] Send Block Student Failure',
  ClearBlockStudentErrors = '[Users-changes] Clear Block Student Errors',

  SendUserUnlockRequest = '[Users-changes] Send User Unlock Request',
  SendUserUnlockSuccess = '[Users-changes] Send User Unlock Success',
  SendUserUnlockFailure = '[Users-changes] Send User Unlock Failure',
  ClearUserUnlockErrors = '[Users-changes] Clear User Unlock Errors',

  SendNoteAboutStudentRequest = '[Users-changes] Send Note About Student Request',
  SendNoteAboutStudentSuccess = '[Users-changes] Send Note About Student Success',
  SendNoteAboutStudentFailure = '[Users-changes] Send Note About Student Failure',
  ClearNoteAboutStudentErrors = '[Users-changes] Clear Note About Student Errors',

  EditNoteAboutStudentRequest = '[Users-changes] Edit Note About Student Request',
  EditNoteAboutStudentSuccess = '[Users-changes] Edit Note About Student Success',
  EditNoteAboutStudentFailure = '[Users-changes] Edit Note About Student Failure',

  SaveStudentFinalResultsRequest = '[Users-changes] Save Student Final Results Request',
  SaveStudentFinalResultsSuccess = '[Users-changes] Save Student Final Results Success',
  SaveStudentFinalResultsFailure = '[Users-changes] Save Student Final Results Failure',
  ClearSaveStudentFinalResults = '[Users-changes] Clear Save Student Final Results Failure',

  DeleteStudentFinalResultRequest = '[Users-changes] Delete Student Final Result Request',
  DeleteStudentFinalResultSuccess = '[Users-changes] Delete Student Final Result Success',
  DeleteStudentFinalResultFailure = '[Users-changes] Delete Student Final Result failure',
  ClearDeleteStudentFinalResult = '[Users-changes] Clear Delete Student Final Result',
  ResetAllTakenStudentsWorksRequest = '[Users-changes] Reset All Taken Students Works Request',
  ResetAllTakenStudentsWorksSuccess = '[Users-changes] Reset All Taken Students Works Success',
  ResetAllTakenStudentsWorksFailure = '[Users-changes] Reset All Taken Students Works Failure',
  ClearResetAllTakenStudentsWorks = '[Users-changes] Clear Reset All Taken Students Works',

  DeleteHappyPointRequest = '[Users-changes] Delete Happy Point Request',
  DeleteHappyPointSuccess = '[Users-changes] Delete Happy Point Success',
  DeleteHappyPointFailure = '[Users-changes] Delete Happy Point Failure',
  ClearDeleteHappyPoint = '[Users-changes] Clear Delete Happy Point',
}

export class ResetState implements Action {
  public readonly type = EUsersChangesActions.ResetState;
}

export class ResetAllTakenStudentsWorksRequest implements Action {
  public readonly type = EUsersChangesActions.ResetAllTakenStudentsWorksRequest;

  constructor(public id: number) {}
}

export class ResetAllTakenStudentsWorksSuccess implements Action {
  public readonly type = EUsersChangesActions.ResetAllTakenStudentsWorksSuccess;
}

export class ResetAllTakenStudentsWorksFailure implements Action {
  public readonly type = EUsersChangesActions.ResetAllTakenStudentsWorksFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearResetAllTakenStudentsWorks implements Action {
  public readonly type = EUsersChangesActions.ClearResetAllTakenStudentsWorks;
}

export class DeleteUserRequest implements Action {
  public readonly type = EUsersChangesActions.DeleteUserRequest;

  constructor(public id: number, public options?: { navTo?: string }) {}
}

export class DeleteUserSuccess implements Action {
  public readonly type = EUsersChangesActions.DeleteUserSuccess;
}

export class DeleteUserFailure implements Action {
  public readonly type = EUsersChangesActions.DeleteUserFailure;

  constructor(public errors: IFormErrors) {}
}

export class EditUserRequest implements Action {
  public readonly type = EUsersChangesActions.EditUserRequest;

  constructor(
    public id: number,
    public userData: IUser,
    public options?: { message?: string; navTo?: string }
  ) {}
}

export class EditUserSuccess implements Action {
  public readonly type = EUsersChangesActions.EditUserSuccess;

  constructor(public user: IUser) {}
}

export class EditUserFailure implements Action {
  public readonly type = EUsersChangesActions.EditUserFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class SendBlockStudentRequest implements Action {
  public readonly type = EUsersChangesActions.SendBlockStudentRequest;

  constructor(public id: number) {}
}

export class SendBlockStudentSuccess implements Action {
  public readonly type = EUsersChangesActions.SendBlockStudentSuccess;
}

export class SendBlockStudentFailure implements Action {
  public readonly type = EUsersChangesActions.SendBlockStudentFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearBlockStudentErrors implements Action {
  public readonly type = EUsersChangesActions.ClearBlockStudentErrors;
}

export class SendUserUnlockRequest implements Action {
  public readonly type = EUsersChangesActions.SendUserUnlockRequest;

  constructor(public id: number) {}
}

export class SendUserUnlockSuccess implements Action {
  public readonly type = EUsersChangesActions.SendUserUnlockSuccess;
}

export class SendUserUnlockFailure implements Action {
  public readonly type = EUsersChangesActions.SendUserUnlockFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearUserUnlockErrors implements Action {
  public readonly type = EUsersChangesActions.ClearUserUnlockErrors;
}

export class SendNoteAboutStudentRequest implements Action {
  public readonly type = EUsersChangesActions.SendNoteAboutStudentRequest;

  constructor(public data: INoteData) {}
}

export class SendNoteAboutStudentSuccess implements Action {
  public readonly type = EUsersChangesActions.SendNoteAboutStudentSuccess;
}

export class SendNoteAboutStudentFailure implements Action {
  public readonly type = EUsersChangesActions.SendNoteAboutStudentFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearNoteAboutStudentErrors implements Action {
  public readonly type = EUsersChangesActions.ClearNoteAboutStudentErrors;
}

export class EditNoteAboutStudentRequest implements Action {
  public readonly type = EUsersChangesActions.EditNoteAboutStudentRequest;

  constructor(
    public id: number,
    public data: INoteData,
    public isEditor?: boolean
  ) {}
}

export class EditNoteAboutStudentSuccess implements Action {
  public readonly type = EUsersChangesActions.EditNoteAboutStudentSuccess;
}

export class EditNoteAboutStudentFailure implements Action {
  public readonly type = EUsersChangesActions.EditNoteAboutStudentFailure;

  constructor(public errors: IFormErrors) {}
}

export class SaveStudentFinalResultsRequest implements Action {
  public readonly type = EUsersChangesActions.SaveStudentFinalResultsRequest;

  constructor(
    public userId: number,
    public data: IStudentGenerateFinalResults
  ) {}
}

export class SaveStudentFinalResultsSuccess implements Action {
  public readonly type = EUsersChangesActions.SaveStudentFinalResultsSuccess;
}

export class SaveStudentFinalResultsFailure implements Action {
  public readonly type = EUsersChangesActions.SaveStudentFinalResultsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearSaveStudentFinalResults implements Action {
  public readonly type = EUsersChangesActions.ClearSaveStudentFinalResults;
}

export class DeleteStudentFinalResultRequest implements Action {
  public readonly type = EUsersChangesActions.DeleteStudentFinalResultRequest;

  constructor(public id: number) {}
}

export class DeleteStudentFinalResultSuccess implements Action {
  public readonly type = EUsersChangesActions.DeleteStudentFinalResultSuccess;
}

export class DeleteStudentFinalResultFailure implements Action {
  public readonly type = EUsersChangesActions.DeleteStudentFinalResultFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteStudentFinalResult implements Action {
  public readonly type = EUsersChangesActions.ClearDeleteStudentFinalResult;
}

export class DeleteStudentHappyPointRequest implements Action {
  public readonly type = EUsersChangesActions.DeleteHappyPointRequest;

  constructor(
    public group: number,
    public period: number,
    public student: number
  ) {}
}

export class DeleteStudentHappyPointSuccess implements Action {
  public readonly type = EUsersChangesActions.DeleteHappyPointSuccess;
}

export class DeleteStudentHappyPointFailure implements Action {
  public readonly type = EUsersChangesActions.DeleteHappyPointFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeleteStudentHappyPoint implements Action {
  public readonly type = EUsersChangesActions.ClearDeleteHappyPoint;
}

export type UsersChangesActions =
  | ResetState
  | EditUserRequest
  | EditUserSuccess
  | EditUserFailure
  | DeleteUserRequest
  | DeleteUserSuccess
  | DeleteUserFailure
  | SendBlockStudentRequest
  | SendBlockStudentSuccess
  | SendBlockStudentFailure
  | ClearBlockStudentErrors
  | SendUserUnlockRequest
  | SendUserUnlockSuccess
  | SendUserUnlockFailure
  | ClearUserUnlockErrors
  | SendNoteAboutStudentRequest
  | SendNoteAboutStudentSuccess
  | SendNoteAboutStudentFailure
  | EditNoteAboutStudentRequest
  | EditNoteAboutStudentSuccess
  | EditNoteAboutStudentFailure
  | ClearNoteAboutStudentErrors
  | SaveStudentFinalResultsRequest
  | SaveStudentFinalResultsSuccess
  | SaveStudentFinalResultsFailure
  | ClearSaveStudentFinalResults
  | DeleteStudentFinalResultRequest
  | DeleteStudentFinalResultSuccess
  | DeleteStudentFinalResultFailure
  | ClearDeleteStudentFinalResult
  | ResetAllTakenStudentsWorksRequest
  | ResetAllTakenStudentsWorksSuccess
  | ResetAllTakenStudentsWorksFailure
  | ClearResetAllTakenStudentsWorks
  | DeleteStudentHappyPointRequest
  | DeleteStudentHappyPointSuccess
  | DeleteStudentHappyPointFailure
  | ClearDeleteStudentHappyPoint;
